//include 10
jQuery(function () {
	window.pixelpoint.ppComponents.orderBy = function ($this) {
		$this.find('.order-element').each(function () {
			const orderValue = $(this).data('order-value');
			const states = {
				asc    : {
					direction: 'ASC',
					title    : $(this).data('title-asc'),
					next     : 'desc'
				},
				desc   : {
					direction: 'DESC',
					title    : $(this).data('title-desc'),
					next     : 'neutral'
				},
				neutral: {
					direction: '',
					title    : $(this).attr('title'),
					next     : 'asc'
				}
			};
			const toStateObject = (state) => {
				if (!state) {
					return states.asc;
				}
				if (typeof state === 'string' || state instanceof String) {
					var stateKey = state.toLowerCase();
					return !!states[stateKey]
						? states[stateKey]
						: states.asc;
				}
				else {
					if (
						typeof state === 'object' &&
						!Array.isArray(state) &&
						state !== null &&
						state.hasOwnProperty('direction')
					) {
						return state;
					}
					else {
						return states.asc;
					}
				}
			};
			$(this).on('click', function () {
				const orderDirection = toStateObject($(this).data('order-direction'));
				const nextOrderDirection = states[orderDirection.next || 'desc'];
				$this.find('.filters_order').val(orderValue);
				$this.find('.filters_order_direction').val(orderDirection);
				$this.find('.filters_order').val(orderValue);
				$this.find('.filters_order_direction').val(orderDirection.direction);
				$this.find('.order-element').removeClass('active');
				$(this).data('order-direction', nextOrderDirection);
				$(this).removeClass('ASC DESC').addClass(orderDirection.direction);
				!!orderDirection.direction && $(this).addClass('active');
				$(this).attr('title', orderDirection.title);
				$this.closest('form').submit();
			});
		});
	};
	$('[data-order-by]').each(function () {
		window.pixelpoint.ppComponents.orderBy($(this));
	});
});